import { QueryStatus, useQuery } from '@tanstack/react-query';

import { fetchGalleryScenes } from './fetchGalleryScenes';
import useSite from './useSite';
import { CubemapProjection, EquirectProjection } from '@egjs/view360';
import { useMemo } from 'react';
import { GallerySceneType } from '../CommonTypes';

export default function useGalleryScenes(type: string) {
  const [site] = useSite();

  const results = useQuery({
    queryKey: ['company', site.company, 'siteId', site.siteid, 'galleryScenes'],
    queryFn: () => fetchGalleryScenes(site.company, site.siteid),
  });

  const galleryScenes = useMemo(() => {
    if (!results?.data) return [];

    if (type == 'cube') {
      return results.data.map(scene => {
        return {
          ...scene,
          projection: new CubemapProjection({
            src: [
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fpx.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fnx.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fpy.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fny.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fpz.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
              `https://firebasestorage.googleapis.com/v0/b/bostadsplanerare.appspot.com/o/${site.company}%2F360tiles%2F${site.sitename}%2F${scene.name}%2Fnz.jpg?alt=media&token=23d6a4cf-dcbe-46be-af6e-c13760da85f8`,
            ],
          }),
        };
      });
    } else {
      return results.data.map(scene => ({
        ...scene,
        projection: new EquirectProjection({ src: scene.imageurl }),
      }));
    }
  }, [results?.data]);

  return [galleryScenes ?? [], results.status] as [GallerySceneType[], QueryStatus];
}
